export default {"src":"/_next/static/media/gardespetsitter.f62d6c15.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};